import React, { useState } from "react";
import styles from "./AutoAssignModal.module.css";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../../../firebase-config";
import closeIcon from "../../../../../assets/close.png";
import ButtonComponent from "../../../../../components/CssComponents/ButtonComponent/ButtonComponent";
import { notification } from "antd";
import { setTargetToClubAdmin } from "../../../../../service/targets/setTargetToClubAdmin";

function SetTargetModal({ isTargetModal, fetchSalesData, setIsTargetModal }) {
  const [targetNumber, setTargetNumber] = useState("");
  const [targetMonth, setTargetMonth] = useState("");
  const [targetYear, setTargetYear] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!targetNumber || !targetMonth || !targetYear) {
      alert("Please fill all fields.");
      return;
    }
    //Check if year is exactly 4 digits
    if (!/^\d{4}$/.test(targetYear)) {
      notification.warning({
        message: "Please enter a valid 4-digit year, e.g., 2025.",
        placement: "topRight",
        duration: 3,
      });
      return;
    }
    try {
      // Step 1: Check if target already exists
      const targetRef = collection(db, "targets");
      const q = query(
        targetRef,
        where("targetMonth", "==", parseInt(targetMonth)),
        where("targetYear", "==", parseInt(targetYear))
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Already exists
        notification.warning({
          message: "Duplicate Target",
          description: `A target for Month ${targetMonth} and Year ${targetYear} already exists.`,
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      // Step 2: Add new target
      await addDoc(targetRef, {
        targetNumber: parseInt(targetNumber),
        targetMonth: parseInt(targetMonth),
        targetYear: parseInt(targetYear),
        createdAt: new Date(),
      });
      await fetchSalesData();
      notification.success({
        message: "Target Added",
        description: "Target successfully set.",
        placement: "topRight",
        duration: 3,
      });

      // Reset modal + inputs
      setIsTargetModal(false);
      setTargetNumber("");
      setTargetMonth("");
      setTargetYear("");
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Error setting target",
        placement: "topRight",
        duration: 3,
      });
      console.error("Error adding target:", error);
    }
  };

  return (
    <div
      className={
        isTargetModal
          ? `${styles.modal} ${styles.displayBlock}`
          : `${styles.modal} ${styles.displayNone}`
      }
    >
      <div className={styles.modalMain}>
        <button
          className={styles.closeBtn}
          onClick={() => setIsTargetModal(false)}
        >
          <img src={closeIcon} alt="Close" />
        </button>
        <div className={styles.mainContent}>
          <div className={styles.title}>Set Target</div>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Number</div>
              <input
                type="number"
                className={styles.input}
                value={targetNumber}
                onChange={(e) => setTargetNumber(e.target.value)}
                placeholder="Enter target Amount"
                required
              />
            </div>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Month</div>
              <input
                type="number"
                className={styles.input}
                value={targetMonth}
                onChange={(e) => setTargetMonth(e.target.value)}
                placeholder="Enter target month (1-12)"
                min="1"
                max="12"
                required
              />
            </div>
            <div className={styles.labelInputWrapper}>
              <div className={styles.labelText}>Target Year</div>
              <input
                type="number"
                className={styles.input}
                value={targetYear}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val.length <= 4) {
                    setTargetYear(val);
                  }
                }}
                placeholder="Enter target year"
                required
              />
            </div>
            <ButtonComponent buttonText={"Set Target"} buttonType="submit" />
          </form>
        </div>
      </div>
    </div>
  );
}

export default SetTargetModal;
